var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWideLogoGreen = function SvgWideLogoGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 929.8 55.57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #009347;\n      }\n\n      .cls-2 {\n        fill: #97c940;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181,48.24c-2.72,2.81-8.41,7.33-19.4,7.33-15.82,0-28.22-10.45-28.22-27.75S145.88.08,161.55.08c11.07,0,17.07,4.6,18.47,6.08l-3.9,10.44c-1-1.32-6.78-5.61-13.87-5.61-9.12,0-16.13,6.08-16.13,16.6s7.32,16.52,16.13,16.52a19.83,19.83,0,0,0,14.5-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.93,54.63H220.31V32.11H198.72V54.63H186.09V.86h12.63V21.67h21.59V.86h12.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255,54.63H242.36V.86H255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.09,48.24c-2.73,2.81-8.42,7.33-19.41,7.33-15.82,0-28.21-10.45-28.21-27.75S274,.08,289.68.08c11.07,0,17.07,4.6,18.47,6.08L304.26,16.6c-1-1.32-6.78-5.61-13.88-5.61-9.12,0-16.13,6.08-16.13,16.6s7.33,16.52,16.13,16.52a19.81,19.81,0,0,0,14.5-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.81,54.63H352.09L348.28,43.8H329.1l-3.81,10.83h-13.1L332.46.78h13.09ZM345.39,34l-6.7-19.33L332,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.7,46.29c-2.74,2.42-9.12,9.2-23.93,9.2s-28-9.82-28-27.74S379.88.08,394.93.08c14.26,0,20.41,7.48,22.13,9.35l-8.34,7.25a17.8,17.8,0,0,0-13.79-6.16c-8.66,0-15.36,6.32-15.36,17.23S386.43,45,395.16,45s11.22-3.43,11.22-3.43V33.59h-11.3V24H418.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.59,55.57c-16,0-28.53-10.37-28.53-27.75S438.61,0,454.59,0s28.52,10.44,28.52,27.82S470.56,55.57,454.59,55.57Zm0-44.81c-9,0-15.75,6.46-15.75,16.75s6.78,16.84,15.75,16.84,15.74-6.55,15.74-16.84S463.55,10.76,454.59,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,.8V20.21H109V.8ZM0,54.57H109V35.16H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602,54.57h12.61V.83H602Zm51-22.2c4-1.24,10.51-5.22,10.51-15.42a14.89,14.89,0,0,0-5.92-12.3c-3.5-2.57-8.18-3.82-14.17-3.82H624.12V54.57h12.62V34h4L652,54.57h14.65Zm-4.91-9.5c-1.56,1.17-3.58,1.48-6.46,1.48h-5V10.57h5c2.88,0,4.9.23,6.46,1.4a6.11,6.11,0,0,1,2.73,5.45A6,6,0,0,1,648.11,22.87ZM544.9,24H525.12V10.88h21V.83H512.58V54.57h12.54V34.09H544.9ZM564.72.76,544.47,54.57h13.08l3.82-10.83h19.16l3.81,10.83h13.71L577.8.76Zm-.47,33.17L571,14.62l6.7,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M730.65,10.58H716.52V55.17H703.67V10.58H689.54V.42h41.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.26,55.17H763.34l-11.5-20.94h-4.05V55.17H734.94V.42h19.68c6.11,0,10.87,1.27,14.44,3.89a15.17,15.17,0,0,1,6,12.54c0,10.39-6.67,14.44-10.72,15.71Zm-18.88-43.4c-1.59-1.19-3.65-1.43-6.59-1.43h-5.08V24.39h5.08c2.94,0,5-.32,6.59-1.51a6.14,6.14,0,0,0,2.77-5.56A6.23,6.23,0,0,0,759.38,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834.19,55.17h-14l-3.89-11H796.81l-3.89,11H779.59L800.22.34h13.33Zm-20.8-21-6.82-19.68-6.82,19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.89,48.67c-4.52,3.81-11.58,6.5-21.11,6.5H838.22V.42h18.56c9.53,0,16.59,2.7,21.11,6.59s8.89,10.16,8.89,20.79S882.5,44.78,877.89,48.67Zm-9-33.73c-2.3-2.14-6.11-3.89-11.43-3.89H851V44.31h6.51c5.32,0,9.13-1.75,11.43-4s4.84-5.8,4.84-12.54S871.23,17.17,868.93,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M929.8,55.17H893.62V.42h35.47V10.66h-22.7V21.85h21.43V32.08H906.39v12.7H929.8Z"
  })))));
};

export default SvgWideLogoGreen;